import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core';

import { getI18n } from "../../../utils/intl";

import styles from './styles';

const NoData = ({ height = 500 }) => {
  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  return (
    <div className={classes.noDataContainer} style={{ height }}>
      {intl.getI18nMessage('label.analytics.dashboard.noData.text')}
    </div>
  );
};

NoData.propTypes = {
  height: PropTypes.number,
}

export default NoData;
